var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.tokens),function(token){return _c('v-col',{key:token.tokenId,attrs:{"cols":"4"}},[_c('TokenCard',{attrs:{"tokenId":token.tokenId}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }